module.exports = __webpack_public_path__ + "static/Gotham-BoldItalic-13c82f72f5c0f63f94c94c8e8694a02a.woff2";